import loglevel from "loglevel";

const logger = loglevel.getLogger("developmentLogger");
logger.setDefaultLevel(loglevel.levels.DEBUG);

export const developmentLogger = logger;
